window.addEventListener('DOMContentLoaded', () => {
    const maxHeight = 750;
    const toggles = document.querySelectorAll('[data-uncollapse]');
    const contentClass = '.collapse__content';
    const contentInner = '.collapse__inner';

    const onToggle = (e) => {
        const content = e.target.closest(contentClass);
        content.style.maxHeight = getTargetHeight(e.target) + 'px';
        content.classList.remove('collapsed');
    };

    const getTargetHeight = (toggle) => {
        const target = toggle.closest(contentInner);
        return target.offsetHeight;
    };

    for (const toggle of toggles) {
        toggle.addEventListener('click', onToggle);
        if (getTargetHeight(toggle) > maxHeight) {
            toggle.closest(contentClass).classList.add('collapsed');
        }
    }


});